<input
      class="form-control"
      type="text"
      (blur)="onBlur()"
      [required]="required"
      [disabled]="disabled"
      [(ngModel)]="value"
      (ngModelChange)="onChange($event)"
      #googleplacesautocomplete
      [style]="style"
      [placeholder]="placeholder">
